import {
  ClickAwayListener,
  Grow,
  Paper,
  Popper,
  Slider,
  Typography,
} from "@mui/material"
import { Stack } from "@mui/system"
import { t } from "i18next"
import VolumeDownIcon from "@mui/icons-material/VolumeDown"
import VolumeUpIcon from "@mui/icons-material/VolumeUp"
import { useAudioSettingsContext } from "contexts/AudioSettingsContext"
import { styles } from "../Controllers.styles"

export default function VolumeOptions({
  open,
  anchorRef,
  onClose = () => {
    console.log("onCloseVolumeOptions")
  },
}) {
  const { audioSettings, setAudioSettings } = useAudioSettingsContext()

  const onVolumechange = (event, newValue) => {
    event?.stopPropagation()
    setAudioSettings({
      ...audioSettings,
      volume: newValue,
    })
  }

  return (
    <Popper
      open={open}
      anchorEl={anchorRef.current}
      role={undefined}
      placeholder="bottom-start"
      transition
      disablePortal
      keepMounted
      popperOptions={{
        placement: "bottom-start",
      }}
      sx={{
        transform: `translateY(60px)!important`,
      }}
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin:
              placement === "bottom" ? "center top" : "center bottom",
          }}
        >
          <Paper sx={styles.controllerContainer}>
            <ClickAwayListener onClickAway={onClose}>
              <Stack
                id="volume-options"
                aria-labelledby="volume-options-button"
              >
                <Typography fontWeight="bold">{t("Volume")}</Typography>
                <Stack
                  direction="row"
                  flex={1}
                  justifyContent="space-between"
                  spacing={2}
                  alignItems="center"
                >
                  <VolumeDownIcon />
                  <Slider
                    aria-label="Volume"
                    step={1}
                    min={0}
                    max={100}
                    defaultValue={audioSettings.volume}
                    value={audioSettings.volume}
                    color="success"
                    sx={styles.volumeSlider}
                    onChange={onVolumechange}
                  />
                  <VolumeUpIcon />
                </Stack>
              </Stack>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  )
}
